import React from 'react';

import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 10px;
  margin-top: 5px;
  background-color: var(--lighter-gray);
`;

const FlexContainer = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
  color: var(--dark-blue);
`;

const DefaultItemRender = (originNode: React.ReactNode, file: any, fileList: any, actions: any, disabled?: boolean) => (
  <Container>
    <FlexContainer href={file.url} target="_blank" rel="noopener noreferrer">
      <CheckCircleFilled style={{ color: 'var(--positive-green)', fontSize: 15, marginRight: '5px' }} />
      <FlexContainer>
        <img alt="attachment" src="/icons/attachment.svg" style={{ marginRight: '5px' }} />
        <span>{file.name}</span>
      </FlexContainer>
    </FlexContainer>
    <CloseOutlined
      style={{ color: 'var(--gray-dark)', fontSize: 10, cursor: disabled ? 'not-allowed' : 'pointer' }}
      onClick={() => {
        if (!disabled) actions.remove();
      }}
    />
  </Container>
);

export default DefaultItemRender;
